/**
 * BannerArea — exibe banners persistentes do M1/M3/M6/etc.
 * R-B02, R-E01, R-E02: banners não-descartáveis pelo Perfil A.
 */

import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import { Banner } from '@/ui';

interface Props {
  modulo: string;  // 'M1', 'M3', etc — filtra os banners cujo modulo_alvo contém este
}

export function BannerArea({ modulo }: Props) {
  const { paebm } = useDataSources();
  const { data: banners = [] } = useQuery({
    queryKey: ['banners', modulo],
    queryFn: () => paebm.listBanners(),
  });

  const visiveis = banners.filter((b) => b.moduloAlvo.includes(modulo));
  if (visiveis.length === 0) return null;

  return (
    <div className="space-y-2 mb-5">
      {visiveis.map((b) => (
        <Banner
          key={b.id}
          tone={b.severidade}
          title={b.titulo}
          description={b.descricao}
          footnote={b.origemRequisito ? `Origem: ${b.origemRequisito}` : undefined}
          label={b.titulo}
        />
      ))}
    </div>
  );
}
